<template>
    <div v-if="address">

        <div class="row" v-if="displayName">
            <div class="col-sm-6 py-0">
                <v-text-field label="First name"  dense height="45" outlined  v-model="address.first_name" :rules="getRules"></v-text-field>
            </div>
            <div class="col-sm-6 py-0">
                <v-text-field label="Last name"  dense height="45" outlined  v-model="address.last_name" :rules="getRules"></v-text-field>
            </div>
        </div>
        <v-text-field label="Business name (optional)" dense height="45" outlined  v-model="address.business_name"></v-text-field>
        <v-text-field label="Address" dense height="45" outlined  v-model="address.street" :rules="getRules"></v-text-field>
        <v-text-field label="Unit, suite, etc. (optional)" dense height="45" outlined  v-model="address.flat_number"></v-text-field>
        <v-text-field label="City" dense height="45" outlined  v-model="address.city" :rules="getRules"></v-text-field>
        <div class="row">
            <div class="col-md-4 py-0">
                <v-select item-text="name" item-value="abbreviation" :return-object="false" :disabled="address.country == null" dense height="45" :items="(address.country)? states(address.country) : []" outlined v-model="address.state" label="State" :rules="getRules"></v-select>
            </div>
            <div class="col-md-4 py-0">
                <v-text-field  label="Zip code" dense height="45" outlined v-model="address.postal" :rules="getRules"></v-text-field>
            </div>
            <div class="col-md-4 py-0">
                <v-select @change="(address.state)? address.state = null : null" dense height="45" :items="countries" outlined v-model="address.country" label="Country" :rules="getRules"></v-select>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <v-text-field  label="Phone" dense height="45" outlined  v-model="address.phone">
                    <template v-slot:append>
                    <v-tooltip bottom>
                        <template v-slot:activator="{on}">
                            <v-icon v-on="on">mdi-map-marker-question</v-icon>
                        </template>
                        <span>In case we need contact with you, about your order.</span>
                    </v-tooltip>
                </template>
                </v-text-field>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props:['value','displayName', 'rules'],
        data:() => {
            return{
                address:null
            }
        },
        computed:{
            getRules(){
                return this.rules ? [] : [this.validationRules.required];
            },
            app(){
                return this.$store.getters.app;
            },
            countries() {
                return Object.keys(this.app.states);
            }
        },
        watch:{
            address(){
                this.$set(this.address, 'name', this.address.first_name+' '+this.address.last_name);
                this.$emit('input', this.address);
            },
            value(){
                if(this.value == null) this.address = {'country': 'AU'}
                else this.address = this.value
            }
        },
        mounted(){
            this.address = this.value;
            if(!this.address){
                this.address = {
                    country: 'AU'
                };
            }
        },
        methods:{
            states(country){
                return this.app.states[country];
            }
        }
    }
</script>
<style>
#app .v-list-item--active {
    color: white!important;
}
#app .v-select__slot input {
    font-weight: 400!important;
}

#app .v-select__selections .v-select__selection {
    font-weight: 400!important;
}
#app .v-select__selections input {
    font-weight: 400!important;
}
</style>
